import React from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { Tooltip } from '@mui/material';
import { colors, typography } from '../../../styles/theme';
import { filterSectionLabelStyle, FILTER_ACCENT_20, FILTER_ACCENT_40 } from './FilterPanel.styles';

/** Altura reservada de la fila de chips (1 línea) para evitar saltos de layout. */
const CHIPS_ROW_MIN_HEIGHT = 28;

const wrapStyle = {
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
};

const chipsRowStyle = {
  display: 'flex',
  flexWrap: 'wrap',
  alignContent: 'flex-start',
  gap: '6px',
  minHeight: `${CHIPS_ROW_MIN_HEIGHT}px`,
  maxHeight: '96px',
  overflowY: 'auto',
};

const emptyHintStyle = {
  display: 'flex',
  alignItems: 'center',
  minHeight: `${CHIPS_ROW_MIN_HEIGHT}px`,
  fontSize: typography.fontSize.xs,
  fontFamily: typography.fontFamily.primary,
  color: colors.textSecondary,
  opacity: 0.75,
};

const chipStyle = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: '4px',
  padding: '4px 8px 4px 10px',
  borderRadius: '999px',
  backgroundColor: FILTER_ACCENT_20,
  border: `1px solid ${FILTER_ACCENT_40}`,
  color: colors.textPanelDescription,
  fontSize: typography.fontSize.xs,
  fontFamily: typography.fontFamily.primary,
  maxWidth: '100%',
};

const labelStyle = {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  maxWidth: '140px',
};

const removeBtnStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: 0,
  border: 'none',
  background: 'none',
  color: colors.textPanelDescription,
  cursor: 'pointer',
  flexShrink: 0,
};

/**
 * Barra sticky de filtros aplicados.
 * Siempre ocupa el mismo slot (vacío o con chips) para no empujar el panel
 * al seleccionar/quitar el primer filtro. El panel no la monta sin sesión.
 * Tooltip con el label completo: los textos largos se recortan en el chip.
 */
function FilterAppliedChips({ chips = [], onRemove }) {
  const hasChips = chips.length > 0;

  return (
    <div style={wrapStyle} aria-label="Filtros aplicados">
      <div style={{ ...filterSectionLabelStyle, marginTop: 0, marginBottom: 0 }}>
        Filtros aplicados
      </div>
      {hasChips ? (
        <div className="filter-panel-scroll" style={chipsRowStyle}>
          {chips.map((chip) => (
            <Tooltip
              key={chip.id}
              title={chip.label}
              placement="top"
              enterDelay={400}
              describeChild
            >
              <span style={chipStyle}>
                <span style={labelStyle}>{chip.label}</span>
                <button
                  type="button"
                  style={removeBtnStyle}
                  aria-label={`Quitar ${chip.label}`}
                  onClick={() => onRemove(chip)}
                >
                  <CloseIcon sx={{ fontSize: 14 }} />
                </button>
              </span>
            </Tooltip>
          ))}
        </div>
      ) : (
        <div style={emptyHintStyle}>Sin filtros activos</div>
      )}
    </div>
  );
}

export default FilterAppliedChips;
